import { render, staticRenderFns } from "./CreateNewSmsTemplatesModal.vue?vue&type=template&id=d36e4f9e"
import script from "./CreateNewSmsTemplatesModal.vue?vue&type=script&lang=js"
export * from "./CreateNewSmsTemplatesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports